<template>
  <portal-layout>
    <div class="shop-page">
      <div class="page-head">
        <h2 class="page-title">课程商城</h2>
      </div>

      <!-- 筛选区 -->
      <div class="filter-card">
        <div class="filter-row">
          <span class="filter-label">课程分类</span>
          <div class="filter-options">
            <span class="filter-option" :class="{ active: currentCateId === '' }"
                  @click="changeCate('')">全部</span>
            <span v-for="cate in cates" :key="cate.id" class="filter-option"
                  :class="{ active: currentCateId === cate.id }"
                  @click="changeCate(cate.id)">{{ cate.name }}</span>
          </div>
        </div>
        <div class="filter-row">
          <span class="filter-label">商品分类</span>
          <div class="filter-options">
            <span class="filter-option" :class="{ active: currentCateCode === '' }"
                  @click="changeCategory('')">全部</span>
            <span v-for="cate in categories" :key="cate.categoryCode" class="filter-option"
                  :class="{ active: currentCateCode === cate.categoryCode }"
                  @click="changeCategory(cate.categoryCode)">{{ cate.categoryName }}</span>
          </div>
        </div>
        <div class="filter-row">
          <span class="filter-label">上课形式</span>
          <div class="filter-options">
            <span class="filter-option" :class="{ active: currentFormat === '' }"
                  @click="changeFormat('')">全部</span>
            <span class="filter-option" :class="{ active: currentFormat === 'live' }"
                  @click="changeFormat('live')">直播</span>
            <span class="filter-option" :class="{ active: currentFormat === 'recorded' }"
                  @click="changeFormat('recorded')">录播</span>
          </div>
        </div>
      </div>

      <!-- 商品列表 -->
      <div v-loading="loading" class="comm-list">
        <div v-if="!loading && comms.length === 0" class="empty-tip">暂无课程商品</div>
        <div v-for="item in comms" :key="item.id" class="comm-item" @click="goDetail(item)">
          <div class="comm-cover">
            <img :src="item.mainPic" :alt="item.title" />
          </div>
          <div class="comm-info">
            <div class="comm-title">{{ item.title }}</div>
            <div class="comm-subtitle">{{ item.subtitle }}</div>
            <div class="comm-meta">
              <el-tag size="mini" :type="item.teachingFormat === 'live' ? 'danger' : ''"
                      effect="plain">
                {{ item.teachingFormat === 'live' ? '直播' : '录播' }}
              </el-tag>
              <span v-if="item.cateName" class="comm-cate">{{ item.cateName }}</span>
            </div>
            <div class="comm-bottom">
              <span class="comm-price">¥{{ item.actualPrice }}</span>
              <span class="comm-sold">{{ item.totalSoldStock }} 人付款</span>
            </div>
          </div>
        </div>
      </div>

      <div v-if="total > 0" class="pagination-container">
        <el-pagination background layout="total, prev, pager, next" :total="total"
                       :current-page.sync="pageNum" :page-size="pageSize"
                       @current-change="queryComms"></el-pagination>
      </div>
    </div>
  </portal-layout>
</template>
<script>
import PortalLayout from '@/components/PortalLayout.vue';
import api from '@/common/api';

export default {
  name: 'PortalCommodityList',
  components: { PortalLayout },
  data() {
    return {
      loading: false,
      cates: [],
      categories: [],
      comms: [],
      total: 0,
      pageNum: 1,
      pageSize: 12,
      currentCateId: '',
      currentCateCode: '',
      currentFormat: ''
    }
  },
  created() {
    this.queryCourseCates();
    this.queryCommCates();
    this.queryComms();
  },
  methods: {
    queryCourseCates() {
      api.course_cate().then((r) => {
        if (r.data.code === "200") {
          // R.ok(List) 走 rows
          this.cates = r.data.rows || [];
        }
      }).catch(() => {});
    },
    queryCommCates() {
      api.comm_cates().then((r) => {
        if (r.data.code === "200") {
          this.categories = r.data.rows || [];
        }
      }).catch(() => {});
    },
    queryComms() {
      this.loading = true;
      api.comms_and_cates({
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        courseCateId: this.currentCateId,
        categoryCode: this.currentCateCode,
        teachingFormat: this.currentFormat
      }).then((r) => {
        if (r.data.code === "200") {
          // 后端 R.ok(page) 走 data 字段，返回 MyBatis-Plus 分页对象
          const page = r.data.data || {};
          this.comms = page.records || [];
          this.total = page.total || 0;
        }
      }).catch(() => {
        // 401 已由 common/api.js 统一跳转登录页
      }).finally(() => {
        this.loading = false;
      });
    },
    changeCate(cateId) {
      this.currentCateId = cateId;
      this.pageNum = 1;
      this.queryComms();
    },
    changeCategory(categoryCode) {
      this.currentCateCode = categoryCode;
      this.pageNum = 1;
      this.queryComms();
    },
    changeFormat(format) {
      this.currentFormat = format;
      this.pageNum = 1;
      this.queryComms();
    },
    goDetail(row) {
      this.$router.push('/portal/shop/detail?id=' + row.id).catch(() => {});
    }
  }
};
</script>
<style scoped>
.page-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}
.page-title {
  font-size: 22px;
  color: #303133;
  margin: 0;
}
.filter-card {
  background-color: #fff;
  border-radius: 8px;
  padding: 20px 25px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  margin-bottom: 20px;
}
.filter-row {
  display: flex;
  align-items: flex-start;
  margin-bottom: 15px;
}
.filter-row:last-child {
  margin-bottom: 0;
}
.filter-label {
  flex-shrink: 0;
  width: 70px;
  font-size: 14px;
  color: #909399;
  line-height: 28px;
}
.filter-options {
  flex: 1;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}
.filter-option {
  display: inline-block;
  padding: 4px 14px;
  font-size: 13px;
  color: #606266;
  border-radius: 14px;
  cursor: pointer;
  transition: all 0.3s;
  line-height: 20px;
}
.filter-option:hover {
  color: #409EFF;
}
.filter-option.active {
  background-color: #409EFF;
  color: #fff;
}
.comm-list {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  min-height: 200px;
}
.comm-item {
  width: calc((100% - 60px) / 4);
  background-color: #fff;
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.3s;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}
.comm-item:hover {
  transform: translateY(-4px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
}
.comm-cover {
  width: 100%;
  height: 150px;
  overflow: hidden;
  background-color: #f5f7fa;
}
.comm-cover img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
.comm-info {
  padding: 12px 15px 15px;
}
.comm-title {
  font-size: 15px;
  color: #303133;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.comm-subtitle {
  font-size: 13px;
  color: #909399;
  margin-top: 6px;
  height: 36px;
  line-height: 18px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.comm-meta {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 8px;
}
.comm-cate {
  font-size: 12px;
  color: #909399;
}
.comm-bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;
}
.comm-price {
  font-size: 17px;
  color: #F56C6C;
  font-weight: bold;
}
.comm-sold {
  font-size: 12px;
  color: #909399;
}
.empty-tip {
  width: 100%;
  text-align: center;
  color: #909399;
  padding: 60px 0;
  font-size: 14px;
}
.pagination-container {
  margin-top: 25px;
  text-align: right;
}
@media (max-width: 1000px) {
  .comm-item {
    width: calc((100% - 20px) / 2);
  }
}
</style>
